import React from "react";
import ProgressCard from "./commonComponents/ProgressCard";
import PerformanceChart from "./commonComponents/PerformanceChart";
import ProgressChart from "./commonComponents/ProgressChart";
import PerformanceCard from "./commonComponents/PerformanceCard";
import styled from "styled-components";

const DashBoardMiddle = () => {
    return (
        <Box>
            <h3>Overall Performance</h3>
            <div className="performanceData">
                <div className="performanceVisual">
                    <PerformanceChart
                        data={[
                            ["AnswerType", "Percentage"],
                            ["Unanswered", 53],
                            ["Wrong answer", 34],
                            ["Correct answer", 23],
                        ]}
                    />
                </div>
                <div className="performanceText">
                    <PerformanceCard
                        signClass="right-sign"
                        cardClass="correctAnswer"
                        // percentage={}
                        text="Correct answer"
                    />
                    <PerformanceCard
                        signClass="cross-sign"
                        cardClass="wrongAnswer"
                        // percentage={}
                        text="Wrong answer"
                    />
                    <PerformanceCard
                        signClass="empty-box"
                        cardClass="unanswered"
                        // percentage={}
                        text="Unanswered"
                    />
                </div>
            </div>
            <h3>Your Progress</h3>
            <p className="progressTitle">35 of 250 MCQs Done</p>
            <div className="progressData">
                <div className="progressVisual">
                    <ProgressChart />
                </div>
                <div className="progressText">
                    <ProgressCard
                        title="Easy"
                        color="#278B28"
                        solvedMcq="35"
                        totalMcq="250"
                    />
                    <ProgressCard
                        title="Medium"
                        color="#E6BF39"
                        solvedMcq="35"
                        totalMcq="250"
                    />
                    <ProgressCard
                        title="Hard"
                        color="#fe4e00"
                        solvedMcq="35"
                        totalMcq="250"
                    />
                </div>
            </div>
        </Box>
    );
};

export default DashBoardMiddle;


const Box = styled.div`
    border: 1.5px solid grey;
    padding: 1rem 2%;
    margin-top: 2rem;
    margin-bottom: 2rem;
    border-radius: 1rem;
    grid-column: 1/2;
    grid-row: 1/3;
    font-size: 2rem;
    box-sizing: border-box;
  
  h3 {
    font-size: 2rem;
  }
  
  .performanceData,
  .progressData {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }
  
  .progressTitle {
    color: grey;
  }
  
  @media (max-width: 800px) {
    .dashBoardMiddle {
      grid-column: 1/3;
      grid-row: 2/3;
      font-size: 2.5rem;

      h3 {
        font-size: 2.5rem;
      }

      .performanceData {
        margin-bottom: 30px;
      }
    }
  }
  
  @media (max-width: 530px) {
    .performanceData,
    .progressData {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 1fr;
      align-items: center;
      row-gap: 30px;
    }
  
    .progressVisual,
    .performanceVisual {
      display: flex;
      justify-content: center;
      margin-right: 6vw;
      height: 100%;
      align-items: flex-start;
    }
  }
  

`